// components/filters/DriveTypeFilterSection.tsx
import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { FilterTag, Wrapper } from '../button/filterTag';
import { useUniversalState } from '../../context/UniversalStateContext';
import type { DisplayedVehicleType } from '../../utils/filterUtils';
import { FilterSection, StyledFieldset, StyledLegend } from './styles';

type Props = {
  allAvailableVehicleTypes: DisplayedVehicleType[];
  selectedVehicleType: DisplayedVehicleType[];
  availableVehicleTypes: DisplayedVehicleType[];
  onClick: (vehicleType: DisplayedVehicleType) => void;
  size: 'sm' | 'md';
  disableUnavailableTypesOnlyWhenFiltered: boolean;
};

export const DriveTypeFilterSection: React.FC<Props> = ({
  allAvailableVehicleTypes,
  selectedVehicleType,
  availableVehicleTypes,
  onClick,
  size,
  disableUnavailableTypesOnlyWhenFiltered,
}) => {
  const { translations } = useUniversalState();
  const fontSize = process.env.IS_LEGACY ? '2' : '3';

  return (
    <FilterSection>
      <StyledFieldset>
        <StyledLegend>
          <Text
            variant={{
              order: fontSize,
              style: 'normal',
              type: 'copy',
            }}
            tag="span"
            margin={[0, 0, 'var(--spacing-relative-2xs)', 0]}
          >
            {translations.filterDriveType}
          </Text>
        </StyledLegend>

        <div translate="no">
          <Wrapper size={size}>
            {allAvailableVehicleTypes.map((id) => {
              const labelText = translations[`vehicleType.${id}`];
              const isSelected = selectedVehicleType.includes(id);
              const isDisabled =
                disableUnavailableTypesOnlyWhenFiltered && !availableVehicleTypes.includes(id);

              return (
                <FilterTag
                  key={id}
                  id={id}
                  text={labelText}
                  onClickHandler={() => onClick(id)}
                  selected={isSelected}
                  disabled={isDisabled}
                  dataTestId={`filterDriveType-${id}`}
                  size={size}
                  {...(id === 'BEV' ? { icon: 'charging' } : {})}
                />
              );
            })}
          </Wrapper>
        </div>
      </StyledFieldset>
    </FilterSection>
  );
};
